
import { Component, Vue, Prop } from "vue-property-decorator";
import { ILbl } from "./ILbl";
import { Tree } from "@/tree/Tree";
import Bus from "@/lib/Bus"; const bus: Bus = new Bus().getBus(); 
import  ButtonVue from "@/lib/Button.vue";
import  ClipUseVue from "@/clip/ClipUse.vue";
import  ClipAddVue from "@/clip/ClipAdd.vue";
import  ClipUseMultiVue from "@/clip/ClipUseMulti.vue";
import  ClipAddMultiVue from "@/clip/ClipAddMulti.vue";
import { IGroup } from "../groups/IGroup";
import { LblSvc } from "./LblSvc"
import { OrderSvc } from "@/order/OrderSvc";
import { IFinder, Finder } from "../finder/IFinder";
import { Debouncer } from "@/lib/Debouncer"
import FinderInlineVue from "@/finder/FinderInline.vue";
import { IPrj } from "@/prj/IPrj";
import SearcherVue from "@/searcher/Searcher.vue"
import { Searcher } from "@/searcher/Searcher";
import PopupVue from "@/lbl/Popoup.vue"
import Popup from "./Popup.vue";
import { MasterData } from "@/store/MasterData";
import Store from "@/store/Store";
import { lbl_api, ILblSvc } from "./ILblSvc"
import { TreeSvc } from "@/tree/TreeSvc";
import  LblShortView from "./LblShort.vue";
import { ObjEvents } from "@/../server/src/mqtt/ObjEvents";

Vue.component("FinderInline", FinderInlineVue);

@Component({ components: { ButtonVue, ClipUseVue, ClipAddVue, ClipUseMultiVue, ClipAddMultiVue,SearcherVue, Popup, LblShortView    } })
export default class LblsVue extends Vue {

  lblSvc=new LblSvc()
  treeSvc=new TreeSvc()
  prj_id:string="";
  prj_idn:string="";
  lbls:ILbl[] = []
  limit:number=999
  lbl_finder:IFinder = new Finder();
  debounced:any;
  filter: string = "";
  searcher:Searcher = new Searcher();
  
  surowiec_podst_finder:IFinder=new Finder();
  surowiec_podst_finder_active=0;
  has_komponenty:boolean=false
  komponenty:any=[]


  key=1;
  lbls_key=0

  async searcher_changed() {
    console.log('searcher changed')
    await this.refresh();
    this.lbls_key++;
  }


  async use_prj_from_clipboard(prj:IPrj) {
    alert("Funkcja deaktywowana")
    return;

  /*
  
    if (!(prj && prj._id && prj.type=="prj")) return;
    const sel = this.get_selected_labels();
    if (sel.length==0) {
      alert("Wybierz najpierw jakieś etykiety")
      return;
    }
    if (!confirm("Przypisać projekt "+prj.idn+" wybranym etykietom (ilość:"+sel.length+") ?")) return;

    for (let i=0;i<sel.length;i++) {
      let lbl:ILbl=sel[i]
      lbl.type = "lbl"      
      const lbl1 =  await this.lblSvc.assign_prj(lbl, prj);

      console.log(lbl1)
      if (lbl1 && lbl1.version) {
        lbl.version = lbl1.version;
        
        if (i<3) alert("Przypisano projekt "+prj.idn+" etykiecie "+lbl.idn)
      } else {
        alert("Problem z przypisaniem projektu "+prj.idn+" etykiecie "+lbl.idn)
      }
      if (i>=3) alert("Przypisano projekt "+prj.idn+" "+sel.length+" etykietom ")

    }
*/
  }

  async use_lbl_from_clipboard(lbl:ILbl) {
    if (!(lbl && lbl._id && lbl.type=="lbl")) return;

    const sel = this.get_selected_labels();
    if (sel.length==0) {
      alert("Wybierz najpierw jakieś etykiety")
      return;
    }
    if (!confirm("Przypisać etykietę "+lbl.idn+" wybranym etykietom (ilość:"+sel.length+") ?")) return;

  }

  async use_tech_from_clipboard(tree:Tree) {
    if (!(tree && tree._id && tree.type=="tree")) return;
    const sel = this.get_selected_labels();
    if (sel.length==0) {
      alert("Wybierz najpierw jakieś etykiety")
      return;
    }
    if (!confirm("Przypisać technologię "+tree.idn+" wybranym etykietom (ilość:"+sel.length+") ?")) return;

    for (let i=0;i<sel.length;i++) {
      let lbl:any=sel[i]
      console.log('**** assing tree lbl.idn', lbl._id)
      console.log(lbl)
      const lbl1 =  await this.lblSvc.assign_tree(lbl._id, tree._id);

      console.log(lbl1)
      if (lbl1 && lbl1.version) {
        lbl.version = lbl1.version;
        alert("Przypisano technologię "+tree._id+" etykiecie "+lbl.idn)
      } else {
        alert("Problem z przypisaniem technologii "+tree._id+" etykiecie "+lbl.idn)
      }
    }
  }


  async use_groups_from_clipboard(groups: IGroup[]) {

    const sel = this.get_selected_labels();
    if (sel.length==0 || !groups || groups.length<=0 ) {
      alert("Wybierz najpierw jakieś etykiety")
      return;
    }
    if (!confirm("Przypisać grupy wybranym etykietom (ilość:"+sel.length+") ?")) return;

    for (let i=0;i<sel.length;i++) {
      let lbl:ILbl=sel[i]

      lbl.groups = groups;

      const lbl1 =  await this.lblSvc.update(lbl)

    }
  }


  get_selected_labels():ILbl[] {
    if (!this.lbls) return[];
    let ret=[]
    for (let i=0;i<this.lbls.length;i++) {
      let lbl:ILbl=this.lbls[i]
      if (lbl.selected) ret.push(lbl)
    }
    return ret;
  }

  async refresh() {
    
    this.lbls=[]
    console.log(">>>>>>>>>>>>>>>>>>>get labels for prj_id", this.prj_id)
    //const lbls: ILbl[] = await this.lblSvc.get_labels_short(this.filter,this.prj_id,this.limit )
    
    const searcher=this.searcher
    const prj_id=this.prj_id
    console.log("searcher",searcher)
    console.log(prj_id)
    searcher.prj_id = prj_id
    const lbls: ILbl[] = await this.lblSvc.get_labels_short(searcher )
    console.log(lbls)
    this.lbls=lbls;
    this.lbls_key++
   
   this.refresh_masterdata()
  }

  async refresh_masterdata() {


    const masterData: MasterData|undefined =  await (await new Store().getStore()).masterData;
    if (!masterData) return;

    this.has_komponenty=false
    const ett="surowiec"+'@'+"ETAP_START"
    this.komponenty         = masterData.komponenty_new[ett]
    if (this.komponenty) {
      this.has_komponenty=true;
      this.update_finder(this.surowiec_podst_finder, this.komponenty)
    }
    this.key++
  }

  async update_finder(finder:Finder, kk:[]) {
    
    if (!finder._id) return;
    (<any> finder).changed = undefined;

    for (let i=0;i<kk.length;i++) {
      let k=<any> kk[i]
      if (k._id == finder._id) {
     
        if (k.text != finder.text) {
          
          (<any> finder).changed = k;
          k.data=finder.data
          k.filter=finder.filter
          this.key++
        }
      }
    }
  }


  async show_lbl(_id:string) {
    if (this.prj_id) {
      window.router.push({ path: `/projekty/${this.prj_id}/etykiety/${_id}` }) 
    } else {
      window.router.push({ path: `/etykiety/${_id}` }) 
    }
  }

  async mounted() {
    console.log('mounted ',this.$route.params)

    bus.register("lbls.komponent_selected", this.komponent_selected)
    bus.register(ObjEvents.status_changed, this.status_changed);


    const prj_id = this.$route.params.prj_id
    this.prj_id = prj_id
    if (prj_id) {
      const prj = await bus.call("/api/projekt/find_by_id", { _id: prj_id } )
      if (prj) {
        
        this.prj_idn = prj.idn
      }
      //await this.refresh();
    } else {
      //this.debounced = Debouncer.debounce(await (this.refresh.bind(this)), 1000).bind(this);
      //await this.refresh();
    }
  }

  beforeDestroy() {
        bus.remove("lbls.komponent_selected", this.komponent_selected)
        bus.remove(ObjEvents.status_changed, this.status_changed);
  }
  /*
  async debounce() {
    await this.debounced()
  }
  */
  

  async create_order() {
    const lbls:ILbl[]=this.get_selected_labels();
    if (!lbls || lbls.length<1) {
      alert("Aby stworzyć zlecenie wybierz co najmniej 1 etykietę!")
      return;
    }

    console.log("")
    const order=await new OrderSvc().create_order(lbls)
    if (order && order._id) {
      alert("Stworzono zlecenie")
      window.router.push({ path: `/zlecenia/${order._id}` }) 
    } else {
      alert("Zlecenie nie mogło zostać utworzone")
    }
  }

  async technologie_projektu(prj_id:string, prj_idn:string) {
    window.router.push({ path: "/projekty/"+prj_id+"/technologie"}) 
  }

  selected(id:any) {
    if (!this.$route.params.lbl_id) return '';
    if (this.$route.params.lbl_id==id ) return 'selected-row';
    return '';
  }
  
  async komponent_selected(e:any) {
      console.log("komponent_selected")
      this.surowiec_podst_finder = e.detail;
      console.log(this.surowiec_podst_finder.data)
      this.surowiec_podst_finder_active=0
  }
  
  async przypisz_surowiec() {

      let go=1
      if (!this.surowiec_podst_finder) go=0;
      if (!this.surowiec_podst_finder.data) go=0;
      if (!this.surowiec_podst_finder.data.data_komponent_nazwa) go=0;
      if (!this.surowiec_podst_finder.data.data_komponent_id) go=0;
      if (!go) {
        alert("Wybierz najpierw surowiec podstawowy")
        return;
      }


      const sel = this.get_selected_labels();
      if (sel.length==0) {
        alert("Wybierz najpierw jakieś etykiety")
        return;
      }
      if (!confirm("Przypisać wybranym plikom komponent "+this.surowiec_podst_finder.data.data_komponent_nazwa+"?")) return;

      for (let i=0;i<sel.length;i++) {
        let lbl:ILbl=sel[i]
        lbl.type = "lbl"   
        lbl.surowiec_podst_finder = this.surowiec_podst_finder   
        
        const lbl1 = await this.lblSvc.update(lbl);

        console.log(lbl1)
        if (lbl1 && lbl1.version) {
          lbl.version = lbl1.version;
          
          if (i<3) alert("Przypisano surowiec "+this.surowiec_podst_finder.data.data_komponent_nazwa+" do pliku "+lbl.idn)
        } else {
          alert("Problem z przypisaniem surowca "+this.surowiec_podst_finder.data.data_komponent_nazwa+" do pliku "+lbl.idn)
        }
      }
  }

  
  async status_changed(e:any) {
      const obj = e.detail;
      console.log("s1")
      if (obj.type!="lbl") return;
      console.log("s2", obj.status)
      if (obj.status!="PREFLIGHT_OK") return;
      console.log("s3")

      await this.refresh()
  }

  async duplicate_lbl(_id: any) {

    const lbl1 = await this.lblSvc.duplicate(_id);
    if (lbl1 && lbl1._id) {
      alert("Skopiowano")
      console.log(lbl1)
    }
    else {
      alert("Problem w kopiowaniu!")
    }
    await this.refresh();

  }



  async technologia_produkcyjna_open(lbl:ILbl) {
    if (!lbl) return;
    if (!lbl._id) return;
    if (!lbl.tree_id) return;
    
    const tree=await this.treeSvc.find_by_id(lbl.tree_id)
    if (!tree?._id) {
      alert("Brak technologii dla tej etykiety")
      return;
    }
    window.router.push({ path: `/technologie/${tree?._id}` }) 
  }

  get_connection_labels():ILbl[] {
    if (!this.lbls) return[];
    let ret=[]
    for (let i=0;i<this.lbls.length;i++) {
      let lbl:ILbl=this.lbls[i]
      if ((<any>lbl).connect) ret.push(lbl)
    }
    return ret;
  }
  
   async connect_lbls() {
    const lbls:ILbl[]=this.get_connection_labels()
    const ret:any  = await new LblSvc().connect_lbls(lbls)
    alert(ret.msgs[0])

    for (let l of lbls) {
        (<any>l).connect=0
    }
    this.refresh()

  }


}
